import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/static/logo.svg")